import script from "./detail_medkon.vue?vue&type=script&setup=true&lang=ts"
export * from "./detail_medkon.vue?vue&type=script&setup=true&lang=ts"

import "./detail_medkon.vue?vue&type=style&index=0&id=6db356f0&lang=css"

const __exports__ = script;

export default __exports__